import { createContext, useContext } from 'react';

/** True once the loader has lifted. Intro choreography waits on this. */
export const ReadyContext = createContext(false);
export const useReady = () => useContext(ReadyContext);
